import React from 'react';
import { NavLink } from 'react-router-dom';

import FooterGasco from '../../assets/images/footer-gasco.svg';

function Footer() {
  return (
    <footer className='h-full lg:h-[465px] !bg-[var(--background-color-primary)]'>
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center px-4 md:px-[15px] lg:px-[80px] xl:px-[183.5px] pt-[76px]">
        <p className='editor-regular text-white !text-[18px] mb-6 lg:mb-0'>Soluciones energéticas para tu negocio. Conversa con uno de nuestros expertos.</p>
        <NavLink to="/contacto" className="!alata-regular !text-[16px] !rounded-[5px] !border-[2px] !border-white !bg-[var(--background-color-primary)] !decoration-none !text-white !w-[180px] !h-[49.41px] flex justify-center items-center !p-0 !m-0">
          Contáctanos
        </NavLink>
      </div>
      <hr className='bg-white mx-4 md:mx-[15px] lg:mx-[80px] xl:mx-[183.5px] opacity-[20%] my-[28px] py-[0.5px]' />
      <div className='w-full flex flex-col lg:flex-row justify-between items-start lg:items-center pl-4 md:pl-[20px] lg:px-[80px] xl:pl-[161px] pr-4 md:pr-[20px] xl:pr-[183.5px]'>
        <img src={FooterGasco} alt="Gasco Footer" className='w-[268px] -ml-6 xl:ml-0 mb-4 lg:mb-0 h-[87px]' />
        <div className='flex flex-col lg:flex-row justify-end items-start lg:items-center gap-y-[12px] gap-x-[52px]'>
          <NavLink to="/" className='!alata-regular text-center !text-white !text-[15px] xl:!text-[18px] hover:underline transition duration-300'>Inicio</NavLink>
          <NavLink to="/soluciones" className='!alata-regular text-center !text-white !text-[15px] xl:!text-[18px] hover:underline transition duration-300'>Industrias</NavLink>
          <NavLink to="/casos-de-exito" className='!alata-regular text-center !text-white !text-[15px] xl:!text-[18px] hover:underline transition duration-300'>Casos de éxito</NavLink>
          <NavLink to="/podcast" className='!alata-regular text-center !text-white !text-[15px] xl:!text-[18px] hover:underline transition duration-300'>Podcast</NavLink>
          <NavLink to="/articulos" className='!alata-regular text-center !text-white !text-[15px] xl:!text-[18px] hover:underline transition duration-300'>Noticias</NavLink>
          <a href="https://www.empresasgasco.com/" className='!alata-regular text-center !text-white !text-[15px] xl:!text-[18px] hover:underline transition duration-300'>Empresas Gasco</a>
        </div>
      </div>
      <hr className='bg-white mx-4 md:mx-[15px] lg:mx-[80px] xl:mx-[183.5px] opacity-[20%] mt-[28px] mb-0 lg:mb-[48px] xl:mb-[76px] py-[0.5px]' />
      <div className='w-full flex justify-center py-8 lg:py-0'>
        <p className='!alata-regular text-[14px] !text-white opacity-75'>© 2025 Gasco Soluciones Energéticas</p>
      </div>
    </footer>
  )
}

export default Footer